import { ReactElement } from 'react';
import classNames from 'classnames';

import { SearchMenuFields } from '../../../types';
import { SearchProvider } from '../providers';
import { SearchMenu } from './SearchMenu';

interface SearchProps {
  fields: SearchMenuFields;
  isDropdown?: boolean;
}

export const Search = ({ isDropdown, fields }: SearchProps): ReactElement => {
  const { searchFilter } = fields;

  return (
    <div
      className={classNames(
        'relative z-20 w-full origin-top-right bg-success',
        isDropdown ? '' : 'min-h-24'
      )}
    >
      <SearchProvider searchFilter={searchFilter?.value}>
        <SearchMenu menuItem={fields} isMenuOpened={isDropdown} />
      </SearchProvider>
    </div>
  );
};
